import type { Customer } from "@shared_types/customer";
import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

const storage = createJSONStorage<string | null>(() => sessionStorage);

export const accessTokenAtom = atomWithStorage<string | null>(
  "accessToken", // The key in sessionStorage
  null, // The initial value if nothing is in storage
  storage, // The storage medium (sessionStorage or localStorage)
  { getOnInit: true } // This tells Jotai to read the value on the first load
);

export const userAtom = atom<Customer | null>(null);
export const isLoggedInAtom = atom((get) => get(accessTokenAtom) !== null);

export const setUserAtom = atom(null, (_, set, user: Customer) => {
  set(userAtom, user);
});
